/** @format */

const template = `
<div class="education-structure-preview">
  <div class="left-arrows-container"> <canvas role="img" class="left-arrows" width="76" height="20" aria-hidden="true"></canvas> </div
  ><div class="left-educations"> <div ng-transclude="left"></div> </div
  ><div class="middle-arrows-container"> <canvas role="img" class="middle-arrows" width="150" height="20" aria-hidden="true"></canvas> </div
  ><div class="right-educations">
    <div ng-transclude="right"></div>
  </div>
</div>
`;
export default template;
